import React, { useState, useEffect } from "react";
import { useThemeContext } from "../../context/ThemeContext";
import { useSelector } from "react-redux";
import { motion } from "framer-motion";
import Sidebar from "../DynamicComponents/SideBar.jsx";
import AdminHeader from "./AdminHeader.jsx";
import Loader from "../Loader";
import { Toaster, toast } from "react-hot-toast";
import API from "../../utils/API";
import CustomTable from "../DynamicComponents/CustomTable.jsx";

const tableConfigs = {
  student: [
    { id: "student-personal-details", label: "Personal Details" },
    { id: "student-previous-education", label: "Previous Education Details" },
    { id: "student-current-education", label: "Current Education Details" },
    { id: "student-society-details", label: "Society Details" },
    { id: "student-previous-placements", label: "Previous Placements" },
    { id: "student-current-placements", label: "Final Year Placement Details" },
    { id: "student-publication-details", label: "Publications" },
    {
      id: "student-higher-education-details",
      label: "Higher Education Details",
    },
    {
      id: "student-entrepreneurship-details",
      label: "Entrepreneurship Details",
    },
    {
      id: "student-extracurricular-details",
      label: "Extracurricular Activities",
    },
    { id: "student-login-activity", label: "Login Activity" },
  ],
  faculty: [
    { id: "faculty-personal-details", label: "Personal Detail" },
    { id: "faculty-association", label: "Designation Details" },
    { id: "faculty-qualification", label: "Qualifications" },
    { id: "faculty-research-papers", label: "Research Papers Published" },
    { id: "faculty-book-records", label: "Book Records Published" },
    { id: "faculty-patent-records", label: "Patent Records" },
    { id: "faculty-interaction", label: "Interaction with the Outside World" },
    { id: "faculty-fdp", label: "FDP/Short Term Training Program" },
    { id: "faculty-guidance", label: "PhD Guidance Details" },
    { id: "faculty-sponsored-research", label: "Sponsored Research" },
    { id: "faculty-consultancy", label: "Consultancy Details" },
  ],
};

const tableFilterConfigs = {
  // Faculty filters
  "faculty-personal-details": [
    { name: "faculty_id", label: "Faculty ID", type: "text" },
    { name: "faculty_name", label: "Faculty Name", type: "text" },
    // {
    //   name: "reset_token_not_null",
    //   label: "Has Reset Token",
    //   type: "select",
    //   options: [
    //     { value: "", label: "All" },
    //     { value: "true", label: "Yes" },
    //     { value: "false", label: "No" },
    //   ],
    // },
    { name: "department_name", label: "Department", type: "text" },
  ],
  "faculty-association": [
    { name: "faculty_id", label: "Faculty ID", type: "text" },
    { name: "faculty_name", label: "Faculty Name", type: "text" },
    { name: "designation", label: "Designation", type: "text" },
  ],
  "faculty-qualification": [
    { name: "faculty_id", label: "Faculty ID", type: "text" },
    { name: "faculty_name", label: "Faculty Name", type: "text" },
    { name: "specialization_name", label: "Specialization", type: "text" },
  ],
  "faculty-research-papers": [
    { name: "faculty_id", label: "Faculty ID", type: "text" },
    { name: "faculty_name", label: "Faculty Name", type: "text" },
    { name: "area_of_research", label: "Research Area", type: "text" },
    { name: "title_of_paper", label: "Paper Title", type: "text" },
    { name: "published_year", label: "Published Year", type: "number" },
    { name: "ISSN_number", label: "ISSN Number", type: "text" },
  ],
  "faculty-book-records": [
    { name: "faculty_id", label: "Faculty ID", type: "text" },
    { name: "faculty_name", label: "Faculty Name", type: "text" },
    { name: "ISBN", label: "ISBN", type: "text" },
    { name: "book_title", label: "Book Title", type: "text" },
  ],
  "faculty-guidance": [
    { name: "faculty_id", label: "Faculty ID", type: "text" },
    { name: "faculty_name", label: "Faculty Name", type: "text" },
    { name: "degree", label: "Degree", type: "text" },
    { name: "passing_year", label: "Passing Year", type: "number" },
  ],
  // Student filters
  "student-personal-details": [
    { name: "roll_no", label: "Roll No", type: "text" },
    { name: "student_name", label: "Student Name", type: "text" },
    { name: "gender", label: "Gender", type: "text" },
  ],
  "student-login-activity": [
    { name: "roll_no", label: "Roll No", type: "text" },
    { name: "student_name", label: "Student Name", type: "text" },
    { name: "login_time_after", label: "Login After", type: "date" },
  ],
  "student-current-education": [
    { name: "roll_no", label: "Roll No", type: "text" },
    { name: "student_name", label: "Student Name", type: "text" },
    { name: "course_name", label: "Course", type: "text" },
    { name: "section", label: "Section", type: "text" },
  ],
  "student-higher-education-details": [
    { name: "roll_no", label: "Roll No", type: "text" },
    { name: "student_name", label: "Student Name", type: "text" },
    { name: "exam_name", label: "Exam Name", type: "text" },
    { name: "institute_name", label: "Institute", type: "text" },
  ],
  "student-current-placements": [
    { name: "roll_no", label: "Roll No", type: "text" },
    { name: "student_name", label: "Student Name", type: "text" },
    { name: "company_name", label: "Company", type: "text" },
    { name: "role_name", label: "Role", type: "text" },
  ],

  "faculty-consultancy": [
    { name: "faculty_id", label: "Faculty ID", type: "text" },
    { name: "faculty_name", label: "Faculty Name", type: "text" },
    { name: "project_title", label: "Project Title", type: "text" },
    { name: "funding_agency", label: "Funding Agency", type: "text" },
    { name: "status", label: "Status", type: "text" },
    { name: "start_date", label: "Start Date", type: "date" },
  ],

  // Student filters
  "student-personal-details": [
    { name: "roll_no", label: "Roll No", type: "text" },
    { name: "student_name", label: "Student Name", type: "text" },
    { name: "gender", label: "Gender", type: "text" },
  ],
  "student-entrepreneurship-details": [
    { name: "roll_no", label: "Roll No", type: "text" },
    { name: "student_name", label: "Student Name", type: "text" },
    { name: "company_name", label: "Company Name", type: "text" },
  ],
  "student-extracurricular-details": [
    { name: "roll_no", label: "Roll No", type: "text" },
    { name: "student_name", label: "Student Name", type: "text" },
    { name: "organizer", label: "Organizer", type: "text" },
    { name: "event_name", label: "Event Name", type: "text" },
    { name: "extracurricular_name", label: "Activity Name", type: "text" },
    { name: "event", label: "Event", type: "text" },
    { name: "event_date_from", label: "Event Date From", type: "date" },
    { name: "event_date_to", label: "Event Date To", type: "date" },
    { name: "position", label: "Position", type: "text" },
  ],
  "student-previous-education": [
    { name: "roll_no", label: "Roll No", type: "text" },
    { name: "student_name", label: "Student Name", type: "text" },
    { name: "course_name", label: "Course Name", type: "text" },
    { name: "institution", label: "Institution", type: "text" },
    { name: "passout_year", label: "Passout Year", type: "number" },
  ],
  "student-previous-placements": [
    { name: "roll_no", label: "Roll No", type: "text" },
    { name: "student_name", label: "Student Name", type: "text" },
    { name: "placement_category", label: "Category", type: "text" },
    { name: "placement_type", label: "Type", type: "text" },
    { name: "company_name", label: "Company", type: "text" },
    { name: "role_name", label: "Role", type: "text" },
  ],
  "student-publication-details": [
    { name: "roll_no", label: "Roll No", type: "text" },
    { name: "student_name", label: "Student Name", type: "text" },
    { name: "type_name", label: "Type", type: "text" },
    { name: "title_of_paper", label: "Paper Title", type: "text" },
    { name: "area_of_research", label: "Research Area", type: "text" },
    { name: "published_year", label: "Published Year", type: "number" },
    { name: "authors", label: "Authors", type: "text" },
    { name: "name_of_publication", label: "Publication Name", type: "text" },
    { name: "ISSN_number", label: "ISSN Number", type: "text" },
  ],
  "student-society-details": [
    { name: "roll_no", label: "Roll No", type: "text" },
    { name: "student_name", label: "Student Name", type: "text" },
    { name: "type", label: "Type", type: "text" },
    { name: "society_name", label: "Society Name", type: "text" },
    { name: "role", label: "Role", type: "text" },
  ],
};
const apiEndpoints = {
  // Faculty endpoints
  "faculty-personal-details": "facultydetails",
  association: "facultyassociation",
  qualification: "facultyspecialization",
  "faculty-research-papers": "facultyresearchpaper",
  "book-records": "facultybookrecords",
  "patent-records": "facultypatentrecords",
  interaction: "facultyinteraction",
  fdp: "facultyfdp",
  phds: "facultyguidance",
  "sponsored-research": "facultysponsoredresearch",
  "faculty-consultancy": "facultyconsultancy",

  // Student endpoints
  "student-personal-details": "studentdetails",
  "student-previous-education": "studentpreviouseducation",
  "student-current-education": "studentcurrenteducation",
  "student-society-details": "studentsociety",
  "student-previous-placements": "studentpreviousplacement",
  "student-current-placements": "studentplacement",
  "student-publication-details": "studentpublication",
  "student-higher-education-details": "studenthighereducation",
  "student-entrepreneurship-details": "studententrepreneurship",
  "student-extracurricular-details": "studentextracurricular",
  "student-login-activity": "studentloginactivity",
};

const Admin = () => {
  const { darkMode } = useThemeContext();
  const [loader, setLoader] = useState(true);
  const [selectedStakeholder, setSelectedStakeholder] = useState("student");
  const [selectedTable, setSelectedTable] = useState(
    "student-personal-details"
  );
  const [filters, setFilters] = useState({});
  const [tableData, setTableData] = useState([]);
  const [dynamicColumns, setDynamicColumns] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [paginationMode, setPaginationMode] = useState("api");
  const { user_id } = useSelector((state) => state.auth.user) || {};

  useEffect(() => {
    const defaultTable = tableConfigs[selectedStakeholder]?.[0]?.id || "";
    setSelectedTable(defaultTable);
    setFilters({});
    setTableData([]);
    setDynamicColumns([]);
    setCurrentPage(1);
  }, [selectedStakeholder]);
  useEffect(() => {
    setTableData([]);
    setDynamicColumns([]);
    setFilters({});
    setCurrentPage(1);
    setTotalItems(0);
  }, [selectedTable]);
  useEffect(() => {
    setTimeout(() => setLoader(false), 1000);
  }, []);

  // useEffect(() => {
  //   const apiPaginationTables = [
  //     "student-personal-details",
  //     "previous-education",
  //     "society-details",
  //     "faculty-personal-details",
  //     "current-education",
  //     "association",
  //     "qualification",
  //   ];
  //   setPaginationMode(
  //     apiPaginationTables.includes(selectedTable) ? "api" : "client"
  //   );
  // }, [selectedTable]);

  const handleFilterChange = (name, value) => {
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const generateColumnsFromData = (data) => {
    if (!data || data.length === 0) return [];
    const sampleItem = data[0];
    const keys = Object.keys(sampleItem);

    return keys
      .filter((key) => !["id", "_id"].includes(key))
      .map((key) => ({
        key,
        label: key
          .split("_")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
        type: typeof sampleItem[key] === "number" ? "number" : "text",
      }));
  };

  const getDynamicFilters = () => {
    return (
      tableFilterConfigs[selectedTable] || [
        { name: "id", label: "ID", type: "text" },
        { name: "name", label: "Name", type: "text" },
      ]
    );

    const columns = generateColumnsFromData(tableData);
    return columns.filter(
      (col) =>
        !["actions", "token_expiry", "reset_token", "document"].includes(
          col.key
        )
    );
  };

  const fetchTableData = async (page = 1) => {
    if (isFetching) return;

    setIsFetching(true);
    try {
      const endpoint = apiEndpoints[selectedTable];
      if (!endpoint) {
        toast.error("No API endpoint configured for this table");
        setIsFetching(false);
        return;
      }

      // Prepare params with filters
      const params = {
        ...Object.fromEntries(
          Object.entries(filters).filter(([_, value]) => value !== "")
        ),
        page: page,
        limit: 20,
        user_id: user_id,
      };

      const response = await API.get(`/ece/admin/${endpoint}`, { params });

      let data = [];
      if (response.data.column_headers && response.data.data) {
        data = response.data.data;
        setDynamicColumns(response.data.column_headers);
        setTotalItems(response.data.total || 0);
      } else if (Array.isArray(response.data)) {
        data = response.data;
        setDynamicColumns(generateColumnsFromData(response.data));
        setTotalItems(response.data.length);
      } else if (response.data?.data && Array.isArray(response.data.data)) {
        data = response.data.data;
        setDynamicColumns(generateColumnsFromData(response.data.data));
        setTotalItems(response.data.total || response.data.data.length);
      } else {
        toast.error("Unexpected API response format");
        return;
      }

      setTableData(data);
      setCurrentPage(page);
      toast.success("Data fetched successfully!");
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to fetch data");
      console.error("Fetch error:", error);
    } finally {
      setIsFetching(false);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    fetchTableData(page);
  };

  const handleExport = async () => {
    try {
      const endpoint = apiEndpoints[selectedTable];
      if (!endpoint) {
        toast.error("No export endpoint configured for this table");
        return;
      }

      const params = {
        ...filters,
        user_id: user_id,
      };

      const response = await API.get(`/ece/admin/${endpoint}/export`, {
        params: params,
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${selectedTable}_export.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();

      toast.success("Export started successfully!");
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to export data");
      console.error("Export error:", error);
    }
  };

  const handleTableAction = (action, row) => {
    console.log(`${action} action for row:`, row);
    toast.success(
      `${action} action triggered for ${row.id || row.faculty_id || row.roll_no}`
    );
  };

  const renderFilters = () => {
    const currentFilters = getDynamicFilters();

    return (
      <div
        className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-${Math.min(
          currentFilters.length + 1,
          4
        )} gap-3 mb-4 p-4 rounded-lg`}
        style={{
          backgroundColor: darkMode ? "#0D1117" : "#FFFFFF",
          border: darkMode ? "1px solid #22232B" : "1px solid #E2E8F0",
          boxShadow: darkMode
            ? "0 1px 3px rgba(0, 0, 0, 0.5)"
            : "0 1px 2px rgba(0, 0, 0, 0.05)",
        }}
      >
        {currentFilters.map((filter) => (
          <div key={filter.name} className="flex flex-col space-y-1">
            <label
              className="text-xs font-medium"
              style={{ color: darkMode ? "#A0AEC0" : "#4A5568" }}
            >
              {filter.label}
            </label>
            {filter.options ? (
              <select
                className="p-1.5 text-sm rounded border focus:outline-none focus:ring-1 focus:ring-blue-500"
                style={{
                  backgroundColor: darkMode ? "#1E1E2E" : "#F8FAFC",
                  borderColor: darkMode ? "#2D3748" : "#CBD5E0",
                  color: darkMode ? "#E2E8F0" : "#1A202C",
                }}
                value={filters[filter.name] || ""}
                onChange={(e) =>
                  handleFilterChange(filter.name, e.target.value)
                }
              >
                {filter.options.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            ) : filter.type === "date" ? (
              <input
                type="date"
                className="p-1.5 text-sm rounded border focus:outline-none focus:ring-1 focus:ring-blue-500"
                style={{
                  backgroundColor: darkMode ? "#1E1E2E" : "#F8FAFC",
                  borderColor: darkMode ? "#2D3748" : "#CBD5E0",
                  color: darkMode ? "#E2E8F0" : "#1A202C",
                }}
                value={filters[filter.name] || ""}
                onChange={(e) =>
                  handleFilterChange(filter.name, e.target.value)
                }
              />
            ) : (
              <input
                type={filter.type === "number" ? "number" : "text"}
                className="p-1.5 text-sm rounded border focus:outline-none focus:ring-1 focus:ring-blue-500"
                style={{
                  backgroundColor: darkMode ? "#1E1E2E" : "#F8FAFC",
                  borderColor: darkMode ? "#2D3748" : "#CBD5E0",
                  color: darkMode ? "#E2E8F0" : "#1A202C",
                }}
                value={filters[filter.name] || ""}
                onChange={(e) =>
                  handleFilterChange(filter.name, e.target.value)
                }
                placeholder={filter.label}
              />
            )}
          </div>
        ))}

        <div className="flex items-end space-x-2 sm:col-span-2 lg:col-span-1">
          <motion.button
            className={`px-3 py-1.5 text-sm rounded-md font-medium flex-1 ${
              darkMode
                ? "bg-blue-600 hover:bg-blue-700"
                : "bg-blue-500 hover:bg-blue-600"
            } text-white transition-colors`}
            onClick={() => fetchTableData(1)}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            disabled={isFetching}
          >
            {isFetching ? (
              <span className="flex items-center justify-center">
                <svg
                  className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                Searching...
              </span>
            ) : (
              "Search"
            )}
          </motion.button>

          <motion.button
            className={`px-3 py-1.5 text-sm rounded-md font-medium flex-1 ${
              darkMode
                ? "bg-green-600 hover:bg-green-700"
                : "bg-green-500 hover:bg-green-600"
            } text-white transition-colors`}
            onClick={handleExport}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            disabled={!tableData.length}
          >
            Export
          </motion.button>
        </div>
      </div>
    );
  };

  return (
    <div
      className="pb-4"
      style={{ backgroundColor: darkMode ? "#1E1E2E" : "#F4F5F7" }}
    >
      {loader ? (
        <Loader />
      ) : (
        <>
          <AdminHeader
            selectedStakeholder={selectedStakeholder}
            onStakeholderChange={setSelectedStakeholder}
          />

          <div className="flex mt-4 min-h-screen">
            <div className="flex-shrink-0 sticky top-0 h-screen">
              <Sidebar
                menuItems={tableConfigs[selectedStakeholder] || []}
                selectedItem={selectedTable}
                onSelect={setSelectedTable}
                role="admin"
              />
            </div>

            <div
              className="flex-1 overflow-y-auto px-4 mb-10 pb-10"
              style={{ backgroundColor: darkMode ? "#1E1E2E" : "#F4F5F7" }}
            >
              <div
                className="rounded-2xl shadow-xl w-full mb-6"
                style={{
                  backgroundColor: darkMode ? "#0D1117" : "#FFFFFF",
                  border: darkMode ? "1px solid #22232B" : "1px solid #D1D5DB",
                }}
              >
                <div className="p-4">
                  <h2
                    className="text-xl font-semibold mb-4"
                    style={{ color: darkMode ? "#EAEAEA" : "#1F252E" }}
                  >
                    {tableConfigs[selectedStakeholder]?.find(
                      (t) => t.id === selectedTable
                    )?.label || "Data"}
                  </h2>
                  {renderFilters()}
                </div>

                <div className="p-4">
                  <CustomTable
                    title={`${selectedStakeholder === "student" ? "Student" : "Faculty"} ${tableConfigs[selectedStakeholder]?.find((t) => t.id === selectedTable)?.label || "Data"}`}
                    columns={dynamicColumns}
                    data={tableData}
                    actions={{
                      edit: (row) => handleTableAction("edit", row),
                      delete: (row) => handleTableAction("delete", row),
                    }}
                    itemsPerPage={20} // Match your API limit
                    totalItems={totalItems} // Pass the total items count from API
                    currentPage={currentPage} // Current page from state
                    onPageChange={handlePageChange} // Your page change handler
                    paginationMode={paginationMode} // 'api' or 'client'
                  />
                </div>
              </div>
            </div>
          </div>

          <Toaster
            toastOptions={{
              duration: 3000,
              style: {
                background: darkMode ? "#161722" : "#FFFFFF",
                color: darkMode ? "#F8F9FA" : "#1F252E",
              },
            }}
          />
        </>
      )}
    </div>
  );
};

export default Admin;
